import React, { PropsWithChildren } from 'react';
import { Provider } from '../../api/api.tsx';
import AuthenticatedUser from './AuthenticatedUser.tsx';
import { ToastProvider } from './ToastContext.tsx';

interface ComponentProps {}

const AuthWrapperContent: React.FC<PropsWithChildren<ComponentProps>> = ({ children }) => {
  return <AuthenticatedUser>{children}</AuthenticatedUser>;
};

const AuthWrapper: React.FC<PropsWithChildren<ComponentProps>> = ({ children }) => {
  return (
    <ToastProvider>
      <Provider>
        <AuthWrapperContent>{children}</AuthWrapperContent>
      </Provider>
    </ToastProvider>
  );
};

export default AuthWrapper;
